/* eslint-disable */
// Tiny per-route SEO updater. Sets <title>, meta description, canonical, and
// the og:* / twitter:* counterparts every time the route changes. Crawlers
// that don't run JS still see the defaults in /public/index.html.

import { useEffect } from 'react';

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) return;
  el.setAttribute(attr, value);
}

export default function SEO({ title, description, path }) {
  useEffect(() => {
    const base = window.location.origin;
    const url = base + (path || window.location.pathname);

    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }
    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }
    setMeta('link[rel="canonical"]', 'href', url);
    setMeta('meta[property="og:url"]', 'content', url);
  }, [title, description, path]);
  return null;
}

export const ROUTE_SEO = {
  home: {
    title: 'Larinz Labz · Content That Performs.',
    description: 'AI-powered creative studio for brands that want to stand out and grow fast. Photography, videography, social media, brand strategy.',
  },
  work: {
    title: 'Work · Larinz Labz',
    description: 'Selected portfolio: branding, content production, advertising and interior design across F&B, retail and lifestyle.',
  },
  studio: {
    title: 'Studio · Larinz Labz',
    description: 'Photography, videography and packaging — visuals that stop the scroll and define your brand.',
  },
  about: {
    title: 'About · Larinz Labz',
    description: 'We are a creative studio for brands that perform. Mission, values, and the people behind the work.',
  },
  contact: {
    title: 'Contact · Larinz Labz',
    description: 'Book a free strategy session. Email, Instagram, location and a project form to get started.',
  },
};
